import { render, staticRenderFns } from "./signinbackup.vue?vue&type=template&id=44852c26&scoped=true&"
import script from "./signinbackup.vue?vue&type=script&lang=js&"
export * from "./signinbackup.vue?vue&type=script&lang=js&"
import style0 from "./signinbackup.vue?vue&type=style&index=0&id=44852c26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44852c26",
  null
  
)

export default component.exports